import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';
import SBAPI from "@/util/SBAPI";
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import SBTextbox from './SBTextbox.vue'
import SBSignUpForm from './SBSignUpForm.vue'
import SBNextBack from './SBNextBack.vue'
import SBButtonSmallGray from './SBButtonSmallGray.vue'
import SBButtonSmall from './SBButtonSmall.vue'
import SBKurukuru from './SBKurukuru.vue'
import SBText from './SBText.vue'

export interface SBMailAuthenticationResponse {
    user: SBAPI.User;
    email: string;
    code: string;
}

@Component({
    components: {
        SBTextbox, SBSignUpForm, SBNextBack, SBButtonSmallGray, SBButtonSmall, SBKurukuru, SBText,
    },
})
export default class SBMailAuthentication extends Mixins(SBComponentVue) {
    mode: number = 0
    error: string = "";
    kurukuru: boolean = false;

    email: string = "";
    code: string = "";
    element: HTMLElement = <HTMLElement>document.scrollingElement;

    @Emit("ok")
    public ok(val: SBMailAuthenticationResponse) {
        return val;
    };

    @Emit("back")
    public back() {
        return true;
    };

    public async check1() {
        this.error = "";
        this.kurukuru = true;
        try {
            let res = await SBAPI.MailController.sendMailUsingPOST(this.email, <any>(this.langEnglish ? "en" : undefined)).catch(AxiosErrorHandler);
            if (isAxiosError(res)) {
                this.error = "" + res.data;
            } else {
                this.mode = 1;
            }
        } catch (error) {
            this.error = "" + error;
        }
        this.element.scrollTop = 0;
        this.kurukuru = false;
    }

    public async check2() {
        this.error = "";
        this.kurukuru = true;
        try {
            let res = await SBAPI.MailController.checkCodeUsingPOST(this.code).catch(AxiosErrorHandler);
            if (isAxiosError(res)) {
                this.error = "" + res.data;
            } else {
                let response: SBMailAuthenticationResponse = {
                    user: res.data,
                    email: this.email,
                    code: this.code
                }
                this.ok(response);
            }
        } catch (error) {
        }
        this.element.scrollTop = 0;
        this.kurukuru = false;
    }

    public backButton(value: number) {
        this.mode = value;
        this.element.scrollTop = 0;
    }
}
